/** @format */

import React, { useState, useEffect } from 'react';
import '../css/Masters.css';
import style from '../css/Masters.module.css';
import Master from './cards/Master';

import masters from '../utils/masters';
import { getRemainingTimeUntilMsTimestamp } from '../utils/countdown';

import underline from '../images/line.png';

const Masters = () => {
	let countdownTimestampMs = 'Mon, 31 Aug 2026 23:59:59 GMT-5';

	const defaultRemainingTime = {
		seconds: '00',
		minutes: '00',
		hours: '00',
		days: '00',
	};

	const [remainingTime, setRemainingTime] = useState(defaultRemainingTime);

	function updateRemainingTime(countdown) {
		setRemainingTime(getRemainingTimeUntilMsTimestamp(countdown));
	}

	useEffect(() => {
		const intervalId = setInterval(() => {
			updateRemainingTime(countdownTimestampMs);
		}, 1000);
		return () => clearInterval(intervalId);
	}, [countdownTimestampMs]);

	return (
		<section className='Masters' id='masters'>
			<div className='masters-container container padding'>
				{/* <h1 className='title'>
					POR TIEMPO LIMITADO
					<br />
					OFERTA
					<span>
						<b> ESPECIAL</b>{' '}
					</span>
				</h1> */}

				{/* <div className='off50'>
					<h1>50% DTO EN TODOS LOS MASTERS</h1>
				</div> */}

				{/* <div className={style.cntCountdown}>
					<div className={style.membershipCountdown}>
						<h5 className={style.membershipCountdownTitle}>Termina 31 de agosto</h5>
						<div className={style.membershipCountdownCounter}>
							<div className={style.membershipCountdownCounterItem}>
								<span>Días</span>
								<p>{remainingTime.days}</p>
							</div>
							<div className={style.membershipCountdownCounterItem}>
								<span>Horas</span>
								<p>{remainingTime.hours}</p>
							</div>
							<div className={style.membershipCountdownCounterItem}>
								<span>Minutos</span>
								<p>{remainingTime.minutes}</p>
							</div>
							<div className={style.membershipCountdownCounterItem}>
								<span>Segundos</span>
								<p>{remainingTime.seconds}</p>
							</div>
						</div>
					</div>
				</div> */}

				<h1 className='title2'>
					MÁSTERS
					{/* <img src={underline} alt='underline' className='masters-underline' /> */}
				</h1>

				<div className='masters-content'>
					{masters.map((master, index) => (
						<Master
							key={index}
							image={master.image}
							imageWebp={master.imageWebp}
							video={master.video}
							url={master.page}
							info={master.description}
							title={master.title}
							countdownTimestampMs={master.startDate}
						/>
					))}
				</div>
			</div>
		</section>
	);
};

export default Masters;
